/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import {
  MAX_ADULTS_PER_ROOM,
  MAX_CHILD_AGE,
  MAX_CHILDREN_PER_ROOM,
  MAX_HOTEL_ROOMS,
} from '../../configs/constants';
import { GuestSelectionConfig } from '../../types';
import { getColor, pd } from '@airasia-phoenix/react-native/utils/utils';

export const defaultGuestSelectionConfig: GuestSelectionConfig = {
  MAX_ADULTS_PER_ROOM,
  MIN_ADULTS_PER_ROOM: 1,
  MAX_CHILDREN_PER_ROOM,
  MIN_CHILDREN_PER_ROOM: 0,
  MAX_CHILD_AGE,
  MIN_CHILD_AGE: 0,
  DEFAULT_CHILD_AGE: 1,
  WEB_MAX_HEIGHT: 550,
  MAX_ROOMS: MAX_HOTEL_ROOMS,
  MAX_TOTAL_GUESTS: undefined, // Unlimited for hotel bookings
  AGE_OPTIONS: Array.from({ length: 18 }, (_, i) => i),
  GUEST_SHEET_HEIGHT: 480,
  GUEST_SHEET_FOOTER_HEIGHT: 130,
  DEFAULT_CHILD_AGE_SELECTION: 1,
};

// Default fallback values for optional config properties
export const DEFAULT_CONFIG_VALUES = {
  DEFAULT_CHILD_AGE_SELECTION: 1,
  MIN_CHILD_AGE: 0,
} as const;

// ChildAgePickerSheet specific constants
export const CHILD_AGE_PICKER_CONSTANTS = {
  WEB_CARD_WIDTH: 274,
  WEB_CARD_MAX_HEIGHT: 380,
  WEB_BACKDROP_Z_INDEX: 10000,
  WEB_CARD_Z_INDEX: 10001,
  SHADOW_RADIUS: pd.ref.space.spacing20.px,
  SHADOW_OFFSET_HEIGHT: pd.ref.space.spacing10.px,
  SHADOW_OPACITY: 0.12,
  SHADOW_COLOR: getColor(pd.sys.colour.content_primary),
  BORDER_WIDTH: 1,
  ICON_SIZE: pd.ref.space.spacing30.px,
  WEB_POSITIONING_BOTTOM_MARGIN: pd.ref.space.spacing100.px,
  EDGE_MARGIN: pd.ref.space.spacing10.px,
  GAP: 2,
} as const;

// AgePickerSheet height constant
export const AGE_PICKER_SHEET_HEIGHT = '60%' as const;
